module.exports = __webpack_public_path__ + "img/picture_52.2edf5e68.png";